import { useLocation, useNavigate } from "react-router-dom";
import AuthenticatedRoutes from "./routes/AuthenticatedRoutes";
import UnAuthenticatedRoutes from "./routes/UnauthenticatedRoutes";
import { useEffect } from "react";
import { startTokenRefresh, stopTokenRefresh } from "../api/client";

function App() {
  const token = localStorage.getItem("token");
  const location = useLocation();
  const navigate = useNavigate();

  // Keep the access token fresh while logged in (covers login + hard refresh).
  // Logout stops it explicitly; a 401 stops it via the response interceptor.
  useEffect(() => {
    if (token) startTokenRefresh();
    else stopTokenRefresh();
    return () => stopTokenRefresh();
  }, [token]);

  useEffect(() => {
    if (location.pathname === "/") {
      const role = localStorage.getItem("role");

      const allowedRoles = [
        "SUPER_ADMIN",
        "INSTITUTE_ADMIN",
        "TRAINER",
        "STUDENT",
      ];

      if (token && allowedRoles.includes(role)) {
        navigate("/dashboard", { replace: true });
      } else {
        navigate("/", { replace: true });
      }
    }
  }, [location.pathname, token, navigate]); // Only depend on pathname

  return (
    <div>{token ? <AuthenticatedRoutes /> : <UnAuthenticatedRoutes />}</div>
  );
}

export default App;
